<template>
  <div class="smart-gas-bg" :class="`smart-gas-bg--${variant}`" aria-hidden="true">
    <div class="grid-layer"></div>
    <div class="scan-layer"></div>
    <div class="flow-line flow-line-a">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="flow-line flow-line-b">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="flow-line flow-line-c">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="meter-ring meter-ring-a"></div>
    <div class="meter-ring meter-ring-b"></div>
    <div class="signal-node node-a"></div>
    <div class="signal-node node-b"></div>
    <div class="signal-node node-c"></div>
    <div class="signal-node node-d"></div>
    <div class="gas-flame flame-a"></div>
    <div class="gas-flame flame-b"></div>
    <div class="iot-hub hub-a">
      <span></span><span></span><span></span><span></span>
    </div>
    <div class="iot-hub hub-b">
      <span></span><span></span><span></span><span></span>
    </div>
    <div class="circuit-panel circuit-a"></div>
    <div class="circuit-panel circuit-b"></div>
    <div class="data-strip strip-a"></div>
    <div class="data-strip strip-b"></div>
  </div>
</template>

<script>
export default {
  name: 'SmartGasBackground',
  props: {
    variant: {
      type: String,
      default: 'page'
    }
  }
}
</script>

<style scoped>
.smart-gas-bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  background:
    radial-gradient(circle at 20% 18%, rgba(0, 96, 205, 0.17), transparent 29%),
    radial-gradient(circle at 84% 76%, rgba(0, 138, 255, 0.13), transparent 31%),
    linear-gradient(115deg, rgba(0, 98, 210, 0.11) 0 16%, transparent 17% 100%),
    linear-gradient(245deg, transparent 0 54%, rgba(0, 150, 240, 0.08) 55% 68%, transparent 69% 100%),
    linear-gradient(135deg, #020b1d 0%, #05204a 48%, #07346d 100%);
}

.smart-gas-bg--login {
  background:
    radial-gradient(circle at 18% 16%, rgba(0, 96, 205, 0.18), transparent 31%),
    radial-gradient(circle at 86% 78%, rgba(0, 138, 255, 0.14), transparent 31%),
    linear-gradient(115deg, rgba(0, 98, 210, 0.11) 0 18%, transparent 19% 100%),
    linear-gradient(250deg, transparent 0 50%, rgba(0, 150, 240, 0.08) 51% 67%, transparent 68% 100%),
    linear-gradient(135deg, #02091a 0%, #041e46 48%, #073465 100%);
}

.smart-gas-bg::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(circle at 50% 40%, transparent 0 38%, rgba(0, 0, 0, 0.14) 68%, rgba(0, 0, 0, 0.32) 100%),
    linear-gradient(180deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.16));
}

.grid-layer,
.scan-layer {
  position: absolute;
  inset: 0;
}

.grid-layer {
  opacity: 0.36;
  background-image:
    linear-gradient(rgba(88, 176, 255, 0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(88, 176, 255, 0.07) 1px, transparent 1px),
    linear-gradient(120deg, transparent 0 46%, rgba(0, 210, 255, 0.07) 47%, transparent 49%);
  background-size: 42px 42px, 42px 42px, 220px 220px;
  animation: gas-grid-drift 18s linear infinite;
}

.scan-layer {
  width: 46%;
  transform: skewX(-18deg) translateX(-120%);
  background: linear-gradient(90deg, transparent, rgba(92, 190, 255, 0.12), transparent);
  animation: gas-scan 7s ease-in-out infinite;
}

.flow-line {
  position: absolute;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, transparent, rgba(76, 174, 255, 0.50), rgba(0, 225, 255, 0.42), transparent);
  box-shadow: 0 0 16px rgba(64, 160, 255, 0.22);
}

.flow-line::before,
.flow-line::after {
  content: "";
  position: absolute;
  top: -7px;
  width: 16px;
  height: 16px;
  border: 1px solid rgba(122, 203, 255, 0.42);
  border-radius: 50%;
  background: rgba(4, 21, 52, 0.76);
  box-shadow: 0 0 18px rgba(64, 160, 255, 0.24);
}

.flow-line::before {
  left: 18%;
}

.flow-line::after {
  right: 22%;
}

.flow-line span {
  position: absolute;
  top: -3px;
  left: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d98b28;
  box-shadow: 0 0 12px rgba(255, 150, 48, 0.46);
  animation: gas-pulse-travel 4.8s linear infinite;
}

.flow-line span:nth-child(2) {
  animation-delay: 1.6s;
}

.flow-line span:nth-child(3) {
  animation-delay: 3.2s;
}

.flow-line-a {
  left: -8%;
  top: 28%;
  width: 72%;
  transform: rotate(-8deg);
}

.flow-line-b {
  right: -12%;
  top: 54%;
  width: 78%;
  transform: rotate(10deg);
}

.flow-line-c {
  left: 8%;
  bottom: 18%;
  width: 56%;
  transform: rotate(4deg);
}

.meter-ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(122, 203, 255, 0.20);
  background:
    radial-gradient(circle, transparent 43%, rgba(122, 203, 255, 0.08) 44% 46%, transparent 47%),
    conic-gradient(from 20deg, rgba(255, 179, 66, 0.34), rgba(0, 194, 255, 0.08), rgba(22, 119, 255, 0.34), rgba(255, 179, 66, 0.34));
  -webkit-mask: radial-gradient(circle, transparent 58%, #000 59%);
  mask: radial-gradient(circle, transparent 58%, #000 59%);
  animation: gas-ring-spin 14s linear infinite;
}

.meter-ring-a {
  width: 280px;
  height: 280px;
  right: 8%;
  top: 18%;
}

.meter-ring-b {
  width: 210px;
  height: 210px;
  left: 7%;
  bottom: 8%;
  animation-duration: 18s;
  animation-direction: reverse;
}

.signal-node {
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #4ba7e8;
  box-shadow: 0 0 0 0 rgba(99, 199, 255, 0.34), 0 0 20px rgba(99, 199, 255, 0.48);
  animation: gas-node-pulse 2.8s ease-out infinite;
}

.node-a { left: 21%; top: 31%; }
.node-b { right: 28%; top: 48%; animation-delay: 0.6s; }
.node-c { left: 54%; bottom: 19%; animation-delay: 1.2s; }
.node-d { right: 13%; bottom: 26%; animation-delay: 1.8s; }

.iot-hub {
  position: absolute;
  width: 190px;
  height: 190px;
  border-radius: 50%;
  border: 1px solid rgba(72, 158, 255, 0.12);
  background:
    radial-gradient(circle, rgba(78, 168, 255, 0.16) 0 3px, transparent 4px),
    radial-gradient(circle, transparent 32%, rgba(72, 158, 255, 0.08) 33% 34%, transparent 35%),
    radial-gradient(circle, transparent 55%, rgba(72, 158, 255, 0.07) 56% 57%, transparent 58%);
  box-shadow: inset 0 0 26px rgba(72, 158, 255, 0.05);
  opacity: 0.72;
  animation: iot-hub-rotate 24s linear infinite;
}

.iot-hub::before,
.iot-hub::after {
  content: "";
  position: absolute;
  inset: 30px;
  border-radius: 50%;
  border: 1px dashed rgba(72, 158, 255, 0.12);
}

.iot-hub::after {
  inset: 62px;
  border-color: rgba(255, 156, 56, 0.10);
}

.iot-hub span {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #3f9fe8;
  box-shadow: 0 0 14px rgba(63, 159, 232, 0.42);
}

.iot-hub span:nth-child(1) { left: 91px; top: 18px; }
.iot-hub span:nth-child(2) { right: 24px; top: 90px; }
.iot-hub span:nth-child(3) { left: 92px; bottom: 18px; }
.iot-hub span:nth-child(4) { left: 24px; top: 90px; }

.hub-a {
  right: 7%;
  top: 9%;
}

.hub-b {
  left: 6%;
  bottom: 7%;
  width: 150px;
  height: 150px;
  opacity: 0.50;
  animation-duration: 30s;
  animation-direction: reverse;
}

.hub-b span:nth-child(1) { left: 71px; top: 14px; }
.hub-b span:nth-child(2) { right: 18px; top: 71px; }
.hub-b span:nth-child(3) { left: 71px; bottom: 14px; }
.hub-b span:nth-child(4) { left: 18px; top: 71px; }

.circuit-panel {
  position: absolute;
  width: 240px;
  height: 150px;
  border: 1px solid rgba(72, 158, 255, 0.10);
  border-radius: 8px;
  background:
    linear-gradient(90deg, transparent 0 18px, rgba(72, 158, 255, 0.12) 18px 19px, transparent 19px 100%) 0 22px / 58px 1px repeat-x,
    linear-gradient(180deg, transparent 0 18px, rgba(72, 158, 255, 0.10) 18px 19px, transparent 19px 100%) 24px 0 / 1px 46px repeat-y,
    radial-gradient(circle, rgba(72, 158, 255, 0.24) 0 2px, transparent 3px) 24px 22px / 58px 46px;
  opacity: 0.38;
  animation: circuit-fade 5s ease-in-out infinite;
}

.circuit-a {
  right: 18%;
  bottom: 20%;
}

.circuit-b {
  left: 18%;
  top: 16%;
  transform: scale(0.76);
  opacity: 0.24;
  animation-delay: 1.8s;
}

.gas-flame {
  position: absolute;
  width: 46px;
  height: 62px;
  border-radius: 52% 48% 52% 48%;
  background:
    linear-gradient(155deg, rgba(255, 166, 54, 0.46), rgba(255, 112, 42, 0.26) 44%, rgba(0, 150, 255, 0.08) 72%, transparent 73%);
  box-shadow: 0 0 20px rgba(255, 130, 42, 0.16), 0 0 34px rgba(0, 148, 255, 0.08);
  transform: rotate(var(--flame-rotate, 28deg)) scale(var(--flame-scale, 1));
  opacity: 0.40;
  animation: gas-flame-breathe 3.6s ease-in-out infinite;
}

.gas-flame::after {
  content: "";
  position: absolute;
  left: 15px;
  top: 18px;
  width: 18px;
  height: 28px;
  border-radius: 50% 50% 44% 44%;
  background: rgba(9, 36, 86, 0.62);
}

.flame-a {
  right: 20%;
  top: 28%;
}

.flame-b {
  left: 23%;
  bottom: 18%;
  --flame-rotate: 22deg;
  --flame-scale: 0.72;
  --flame-scale-low: 0.69;
  --flame-scale-high: 0.75;
  animation-delay: 1.1s;
}

.data-strip {
  position: absolute;
  width: 170px;
  height: 76px;
  border: 1px solid rgba(122, 203, 255, 0.12);
  border-radius: 8px;
  background:
    linear-gradient(90deg, rgba(99, 199, 255, 0.26) 0 18%, transparent 18% 100%) 16px 16px / 98px 6px no-repeat,
    linear-gradient(90deg, rgba(255, 179, 66, 0.22) 0 38%, transparent 38% 100%) 16px 34px / 126px 6px no-repeat,
    linear-gradient(90deg, rgba(22, 119, 255, 0.24) 0 56%, transparent 56% 100%) 16px 52px / 116px 6px no-repeat,
    rgba(3, 12, 32, 0.32);
  box-shadow: inset 0 0 14px rgba(99, 199, 255, 0.06);
  transform: translateY(0) scale(var(--strip-scale, 1));
  animation: gas-card-float 5.8s ease-in-out infinite;
}

.strip-a {
  right: 16%;
  bottom: 12%;
}

.strip-b {
  left: 13%;
  top: 14%;
  --strip-scale: 0.82;
  animation-delay: 1.1s;
}

@keyframes gas-grid-drift {
  0% { background-position: 0 0, 0 0, 0 0; }
  100% { background-position: 42px 42px, 42px 42px, 220px 0; }
}

@keyframes gas-scan {
  0%, 12% { transform: skewX(-18deg) translateX(-120%); opacity: 0; }
  20%, 72% { opacity: 1; }
  100% { transform: skewX(-18deg) translateX(280%); opacity: 0; }
}

@keyframes gas-pulse-travel {
  0% { left: 0; opacity: 0; transform: scale(0.7); }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { left: 100%; opacity: 0; transform: scale(1.15); }
}

@keyframes gas-ring-spin {
  to { transform: rotate(360deg); }
}

@keyframes iot-hub-rotate {
  to { transform: rotate(360deg); }
}

@keyframes circuit-fade {
  0%, 100% { opacity: 0.22; }
  50% { opacity: 0.44; }
}

@keyframes gas-node-pulse {
  0% { box-shadow: 0 0 0 0 rgba(99, 199, 255, 0.34), 0 0 18px rgba(99, 199, 255, 0.46); }
  100% { box-shadow: 0 0 0 22px rgba(99, 199, 255, 0), 0 0 22px rgba(255, 179, 66, 0.18); }
}

@keyframes gas-flame-breathe {
  0%, 100% { opacity: 0.26; transform: rotate(var(--flame-rotate, 28deg)) scale(var(--flame-scale-low, 0.96)); }
  50% { opacity: 0.46; transform: rotate(var(--flame-rotate, 28deg)) scale(var(--flame-scale-high, 1.04)); }
}

@keyframes gas-card-float {
  0%, 100% { transform: translateY(0) scale(var(--strip-scale, 1)); opacity: 0.72; }
  50% { transform: translateY(-10px) scale(var(--strip-scale, 1)); opacity: 0.92; }
}

@media (max-width: 768px) {
  .meter-ring-a { right: -70px; top: 12%; }
  .meter-ring-b { left: -80px; bottom: 4%; }
  .data-strip { display: none; }
  .circuit-panel { display: none; }
  .iot-hub { opacity: 0.36; }
  .gas-flame { opacity: 0.42; }
  .flow-line-a { width: 95%; }
  .flow-line-b { width: 100%; }
}

@media (prefers-reduced-motion: reduce) {
  .grid-layer,
  .scan-layer,
  .flow-line span,
  .meter-ring,
  .signal-node,
  .iot-hub,
  .circuit-panel,
  .gas-flame,
  .data-strip {
    animation: none;
  }
}
</style>
